import React from 'react';

import { cn } from '@epoch-ui/lib/utils';

export const DataViewLine = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={cn('tw-flex tw-flex-row tw-items-center tw-gap-4', className)}
      />
    );
  }
);

DataViewLine.displayName = 'DataViewLine';

export const DataViewLineIcon = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'tw-flex tw-h-11 tw-w-11 tw-flex-none tw-items-center tw-justify-center tw-rounded-lg tw-bg-background-grey',
        className
      )}
      {...props}
    />
  );
});

DataViewLineIcon.displayName = 'DataViewLineIcon';

export const DataViewLineContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('tw-flex tw-flex-grow tw-flex-col tw-items-start tw-gap-0.5', className)}
      {...props}
    />
  );
});

DataViewLineContent.displayName = 'DataViewLineContent';

export const DataViewLineHeading = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'tw-flex-none tw-self-stretch tw-border-none tw-leading-5 tw-text-dark-black',
        className
      )}
      {...props}
    />
  );
});

DataViewLineHeading.displayName = 'DataViewLineHeading';

export const DataViewLineSubText = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'tw-order-1 tw-flex-none tw-self-stretch tw-leading-5 tw-text-primary-grey',
        className
      )}
      {...props}
    />
  );
});

DataViewLineSubText.displayName = 'DataViewLineSubText';
